import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { EditorsTitle, QuillEditorTitle } from "../../../../Constants/Constants";
import BubbleTheme from "./BubbleTheme";
import SnowTheme from "./SnowTheme";
import StandardEditor from "./StandardEditor";

const QuillEditorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={QuillEditorTitle} parent={EditorsTitle} />
      <Container fluid>
        <Row>
          <StandardEditor />
          <SnowTheme />
          <BubbleTheme />
        </Row>
      </Container>
    </>
  );
};
export default QuillEditorContainer;
